export interface CampoJuegoTipoPisoJSON {
  cjtp_id: string | null;
  cjtp_descripcion: string;
  cjtp_activo: boolean;
}

export class CampoJuegoTipoPiso {
  protected constructor(private id: string | null, private descripcion: string, private activo: boolean) {}

  static createFrom(id: string | null, descripcion: string, activo: boolean) {
    return new this(id, descripcion, activo);
  }

  isIdentifiedBy(anId: string): boolean {
    return this.id === anId;
  }

  isIdentifiedAs(aEntity: CampoJuegoTipoPiso) {
    if (this.id) {
      return aEntity.isIdentifiedBy(this.id);
    } else {
      return false;
    }
  }

  static fromJSON(entity: CampoJuegoTipoPisoJSON) {
    return CampoJuegoTipoPiso.createFrom(entity.cjtp_id, entity.cjtp_descripcion, entity.cjtp_activo);
  }

  toJSON(): CampoJuegoTipoPisoJSON {
    return {
      cjtp_id: this.getId(),
      cjtp_descripcion: this.getDescripcion(),
      cjtp_activo: this.getActivo(),
    };
  }

  getId(): string | null {
    return this.id;
  }

  getDescripcion(): string {
    return this.descripcion;
  }

  getActivo(): any {
    return this.activo;
  }

  setId(value: string | null): void {
    this.id = value;
  }

  setDescripcion(value: string): void {
    this.descripcion = value;
  }

  setActivo(value: any): void {
    this.activo = value;
  }
}
